import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPopup.css';

const PrivacyPopup = ({ isOpen, onClose, onAccept }) => {
  const [isChecked, setIsChecked] = useState(false);
  
  if (!isOpen) return null;
  
  return (
    <div className="privacy-overlay" onClick={onClose}>
      <div className="privacy-popup" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-header">
          <h2>CONSENT TO THE PROCESSING OF PERSONAL DATA</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="privacy-content">
          <h3>TW Rental Privacy Policy</h3>
          
          <p className="privacy-subtitle">Effective Date: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <p>
            TW Rental ("we," "our," "us") values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect your information when you interact with us, including through SMS or other messaging services.
          </p>

          <h3>1. Information We Collect</h3>
          <p>
            We may collect the following information to provide you with automated customer support and transactional messages:
          </p>
          <ul>
            <li>Your name</li>
            <li>Phone number</li>
            <li>Booking and rental information</li>
            <li>Communication preferences and related details</li>
          </ul>
          <p>
            We collect this information directly from you or from the platform you used to make your rental reservation (such as Turo).
          </p>

          <h3>2. How We Use Your Information</h3>
          <p>
            We use your information solely for purposes directly related to your rental and support experience, including:
          </p>
          <ul>
            <li>Sending booking confirmations and reminders</li>
            <li>Providing pickup and return instructions</li>
            <li>Sharing important support and safety information</li>
            <li>Responding to your inquiries and support requests</li>
          </ul>
          <p>
            We do not use your phone number for marketing or unrelated promotional purposes.
          </p>

          <h3>3. How We Share Your Information</h3>
          <p>
            We do not sell or rent your personal information.
          </p>
          <p>
            We may share limited data with trusted service providers (such as Twilio) to send messages or support customer communication. These providers are required to handle your information securely and in compliance with applicable privacy laws.
          </p>

          <h3>4. Consent and Opt-Out</h3>
          <p>
            By providing your phone number, you consent to receive automated transactional messages from TW Rental regarding your active rental.
          </p>
          <p>
            You can opt out of receiving further messages at any time by replying STOP to any message. After opting out, you will no longer receive messages unless you initiate a new rental or support request.
          </p>

          <h3>5. Data Retention</h3>
          <p>
            We retain your personal information only as long as necessary to fulfill the purposes described above, or as required by law. When your data is no longer needed, we securely delete or anonymize it.
          </p>

          <h3>6. Data Security</h3>
          <p>
            We implement reasonable technical and organizational measures to protect your data against unauthorized access, loss, or misuse.
          </p>

          <h3>7. Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy or our data practices, please contact us at:
          </p>
          <p>📧 support@twrental.com</p>
          <p>📍 105 Spring Heights Ln, Smyrna, GA 30080</p>

          <p className="privacy-note">
            <strong>By clicking on the checkbox below I agree to receive automated text messages from TW Rental related to my rental reservation (e.g., booking confirmations, pickup instructions, support updates, and safety reminders). Message frequency varies. Message and data rates may apply. Reply STOP to cancel or HELP for help.</strong>
          </p>
          
          <div className="privacy-checkbox-container">
            <input 
              type="checkbox" 
              id="privacy-consent-checkbox"
              className="privacy-checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            <label htmlFor="privacy-consent-checkbox" className="privacy-checkbox-label">
              I agree to the terms and conditions
            </label>
          </div>
          
          <p className="privacy-link-container">
            For more information, please read our{' '}
            <Link to="/privacy" className="privacy-link" onClick={(e) => e.stopPropagation()}>
              complete Privacy Policy
            </Link>.
          </p>
        </div>
        
        <div className="privacy-footer">
          <button className="decline-button" onClick={onClose}>
            Decline
          </button>
          <button 
            className="accept-button" 
            onClick={onAccept}
            disabled={!isChecked}
          >
            I Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPopup;
